import React, { useState } from 'react';
import { useBOMStore } from 'src/hooks/bom';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';

const EditProject = (props) => {
    const { translation: t } = System;
    const { addProjectToEditStack, projectData } = props
    const [{ }, { fetch_bom_project_detail_with_bom }, { edit_project }] = useBOMStore();
    const [projectName, SetProjectName] = useState(projectData && projectData.projectName);
    const [projectNameError, SetProjectNameError] = useState('');


    const onSaveProject = async () => {
        let error = false
        if (projectName.trim().length === 0) {
            error = true;
            SetProjectNameError(t('pleaseEnterProjectName'))
        } else if (projectName.trim().length > 100) {
            error = true;
            SetProjectNameError(t('pleaseUseLessThan100Characters'))
        } else {
            SetProjectNameError('')
        }

        if (!error) {
            let params = {}
            params.projectName = projectName;
            params.projectId = projectData.projectId;
            let editRes = await edit_project(params)
            if (editRes.ErrorCode == Constants.errorCode.error400) {
                SetProjectNameError(editRes?.Message)
            }
            if (editRes?.data) {
                await addProjectToEditStack(projectData)
                await fetch_bom_project_detail_with_bom();
            }
        }
    }

    return (
        <>
            <div className="edit-project-box ps-3">
                <input type="text" className={projectNameError ? "form-control form-control-sm mb-2 w295 error" : "form-control form-control-sm mb-2 w295"}
                    id="project"
                    placeholder={t('enterProject')} name="project"
                    value={projectName}
                    onChange={(e) => { SetProjectName(e.target.value) }}
                />
                <p className="error">{projectNameError}</p>
                <p className="w-100 m-b-10 mt-2 "><a className="text-blue2" href={void (0)}
                    onClick={async () => { await addProjectToEditStack(projectData) }}>{t('cancel')} </a>
                    / <a className="text-blue2" data-toggle="modal" href={void (0)}
                        onClick={() => onSaveProject()}>Save</a>
                </p>
            </div>
        </>
    );
}

export default EditProject;